module.exports = ".acl-selector {\n    margin-bottom: 40px;\n}\n\na {\n\tcursor: pointer;\n}\n\n.not-active {\n   pointer-events: none;\n}\n"